import Card from "../components/UI/Card";
import { useHouseContext } from "../HouseContext";
import parse from 'html-react-parser';
import styles from "./Common.module.css";
import img_biberwier from "../assets/biberwier.jpg"
import img_stockach from "../assets/stockach.jpg"
import img_pitztal from "../assets/pitztal.jpg"

function PageSelectLocation() {
  const imgs = [img_stockach, img_pitztal, img_biberwier];
  const houseCtx = useHouseContext();
  return (
    <div className="flex justify-center w-full">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 w-fit">
        {Array.from(houseCtx.houses.values()).map((house, idx) => {
          return (
            <Card
              key={house.houseName}
              src={imgs[idx]}
              title={`Belegung ${house.houseName}`}
              textBtn="Ansehen"
              redirectTo={`/belegung/${house.houseName.toLowerCase()}`}
            >
              <div className={styles.database}>
                {parse(house.description)}
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}

export default PageSelectLocation;
